/**
 * Product Grid Manager - Moon Moon Agency
 * Section MM-Product-Grid : flèche du carrousel hero (3 produits et plus), masquée quand la dernière carte est visible.
 * Les cartes et le glisser sont gérés par mm_product_card_3.js.
 */

/*********************************************************************************************
 * 🛍️ PRODUCT GRID MANAGER
 */
if (!window.MMProductGridManager) {
	const ProductGridManager = {
		config: {
			selectors: {
				hero: '[data-product-grid-hero]',
				heroList: '[data-product-grid-hero-list]',
				heroNext: '[data-product-grid-hero-next]',
			},
		},

		reducedMotionQuery: window.matchMedia('(prefers-reduced-motion: reduce)'),
		heroObserver: null,
		pendingLists: new Set(),

		/**
		 * Initialize the module
		 */
		init() {
			this._bindEvents();
			this._observeHeroes();
			window.log('info', '🛍️ [PRODUCT_GRID]', 'Initialized');
		},

		_bindEvents() {
			document.addEventListener('click', (e) => {
				const button = e.target.closest(this.config.selectors.heroNext);
				if (!button) return;
				const list = button.closest(this.config.selectors.hero)?.querySelector(this.config.selectors.heroList);
				if (list) this.scrollHero(list);
			});

			document.addEventListener('scroll', (e) => {
				const list = e.target;
				if (!(list instanceof Element) || !list.matches(this.config.selectors.heroList)) return;
				if (this.pendingLists.has(list)) return;
				this.pendingLists.add(list);
				requestAnimationFrame(() => {
					this.pendingLists.delete(list);
					this.updateHeroArrow(list);
				});
			}, { capture: true, passive: true });

			document.addEventListener('shopify:section:load', () => this._observeHeroes());
		},

		_observeHeroes() {
			if (!this.heroObserver) {
				this.heroObserver = new ResizeObserver((entries) => {
					entries.forEach((entry) => this.updateHeroArrow(entry.target));
				});
			}
			document.querySelectorAll(this.config.selectors.heroList).forEach((list) => {
				if (list.dataset.productGridHeroBound) return;
				list.dataset.productGridHeroBound = 'true';
				this.heroObserver.observe(list);
			});
		},

		updateHeroArrow(list) {
			const button = list.closest(this.config.selectors.hero)?.querySelector(this.config.selectors.heroNext);
			if (!button) return;
			const last = list.lastElementChild;
			button.hidden = !last || last.getBoundingClientRect().right <= list.getBoundingClientRect().right + 1;
		},

		scrollHero(list) {
			const item = list.firstElementChild;
			if (!item) return;
			const behavior = this.reducedMotionQuery.matches ? 'auto' : 'smooth';
			const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
			list.scrollBy({ left: item.getBoundingClientRect().width + gap, behavior });
		},
	};

	window.MMProductGridManager = ProductGridManager;

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => ProductGridManager.init());
	} else {
		ProductGridManager.init();
	}
}
